import { ChakraFlex, Text } from '@equip.health/ui';
import { STATUS_LABELS } from '../constants';
import type { StatusKey } from '../constants';
import StatusColorDot from './StatusColorDot';

interface MyDayStatusLegendColumnProps {
  statusKey: StatusKey;
  count: number;
  isHovered: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

const MyDayStatusLegendColumn = ({
  statusKey,
  count,
  isHovered,
  onMouseEnter,
  onMouseLeave,
}: MyDayStatusLegendColumnProps) => {
  return (
    <ChakraFlex
      direction="column"
      gap="6px"
      flex="1 1 0"
      minWidth="0"
      cursor="default"
      opacity={isHovered ? 1 : 0.35}
      transition="opacity 150ms ease"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={`my-day-legend-${statusKey}`}
    >
      <ChakraFlex alignItems="flex-start" gap="6px">
        <StatusColorDot statusKey={statusKey} />
        <Text variant="caption">{STATUS_LABELS[statusKey]}</Text>
      </ChakraFlex>
      <Text variant="body" marginTop="auto">
        {count}
      </Text>
    </ChakraFlex>
  );
};

export default MyDayStatusLegendColumn;
